import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/water-intake-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/water-intake-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/water-intake-calculator",
      title: m.water_meta_title(),
      description: m.water_meta_description(),
      toolName: m.water_tool_name(),
      faqs: [
        { q: m.water_faq_q1(), a: m.water_faq_a1() },
        { q: m.water_faq_q2(), a: m.water_faq_a2() },
        { q: m.water_faq_q3(), a: m.water_faq_a3() },
        { q: m.water_faq_q4(), a: m.water_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
